import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateCompanyManager,
  GetAllUsersResponse,
  GetUserDetailsResponse,
  SignupResponse,
  updateUser,
} from '../entities/user.entity';
@Injectable()
export abstract class UsersServices {
  /**
   * All User
   */
  abstract getAllUsers(companyId: string): Observable<GetAllUsersResponse>;

  /**
   * All User
   */
  abstract sendLink(): Observable<any>;

  /**
   * Upload File
   */
  abstract uploadFile(file: any): Observable<any>;

  /**
   * Users Count
   */
  abstract usersCount(companyId: string): Observable<any>;

  /**
   * Users Count
   */
  abstract userDetails(userId: string): Observable<any>;
  /**
   * Users Count
   */
  abstract updateUser(userId: string, userData: updateUser): Observable<any>;

  /**
   * Users Count
   */
  abstract deleteUser(userId: string): Observable<any>;

  /**
   * Forgot Password
   */
  abstract forgotPassword(emailOrUsername: string): Observable<any>;

  /**
   * Reset Password
   */
  abstract resetPassword(resetPasswordData: any): Observable<any>;
  /**
   * Reset Password
   */
  abstract updateCompanyManager(userId: string, userData: any): Observable<any>;
  /**
   * Reset Password
   */
  abstract refreshToken(userId: string): Observable<any>;
  /**
   * Confirm Account
   */
  abstract confirmAccount(confirmAccountToken: string): Observable<any>;
  /**
   * Create Company Manager
   */
  abstract createCompanyManager(
    data: CreateCompanyManager
  ): Observable<SignupResponse>;

  /**
   * Resend Email
   */
  abstract resendEmail(): Observable<GetUserDetailsResponse>;

  abstract sendCode(data: any): Observable<any>;
  abstract confirmAccountV1(token: string): Observable<any>;
  abstract verifyCode(data: any): Observable<any>;
  abstract signUpV3(data: any): Observable<any>;
  abstract verifyAuthToken(data: any): Observable<any>;
  abstract checkEmailExist(email: string): Observable<any>;
}
